function refreshCart(){
		$.ajax({
			url : '/cart?view=slidecart',
			dataType : 'HTML',
			method : "GET",
			success : function(htmlData) {
				let html_markup = $(htmlData);
				let to_replace = $(htmlData).html();
				$('.sidebar_cart').html(to_replace);
				$('body').addClass('open_cart');

// 				$('.countjs-cart-count').text(window.cart_value);
//               let cart_count = $(`[data-cart-itemcount]`).attr('data-cart-itemcount');
//               $(`.countjs-cart-count`).text(cart_count);

              let cart_count = $(`[data-cart-itemcount]`).attr('data-cart-itemcount');
              $(`.countjs-cart-count`).text(cart_count);

              $.get('/cart.json', function (cart) {
                console.log(cart)
                $('.item-count').text(cart.item_count);
         		$('.countjs-cart-count').text(cart.item_count);
                $.each(cart.items, function (index, item) {
                  $(`[data-prodsuggest='${item.product_id}']`).hide();
                });
              });

			}
		})
	}

$(document).ready(function(){

$('.cart-btn').click(function(){
		$.ajax({
			url : '/cart?view=slidecart',
			dataType : 'HTML',
			method : "GET",
			success : function(htmlData) {
				let html_markup = $(htmlData);
				let to_replace = $(htmlData).html();
				$('.sidebar_cart').html(to_replace);
				$('body').addClass('open_cart');
                $('.countjs-cart-count').text(window.cart_value);
                 $.get('/cart.json', function (cart) {
                $.each(cart.items, function (index, item) {
                  $(`[data-prodsuggest='${item.product_id}']`).hide();
                });
              });


			}
		})

    });

});

$(document).on('click','a[data-atc-home-pdp]',function(e){
	  e.preventDefault();
      var id = $(this).attr('data-var-id');
		var qty = $(this).attr('data-qty');
		var data = {
			"quantity": qty,
			"id": id
		}
		$.ajax({
			url : "/cart/add.js",
			method : "POST",
			dataType : "JSON",
			data : data,
			success : function(data) {
              console.log(data)
					refreshCart(data);


			},
			error : function(error) {
				console.log('ERROR');
				console.log(error);
			}
		})
	});
$(document).ready(function(){


   $('.header__icon--cart').click(function(){
        $('body').addClass('open_cart');
    });




$(document).on('click','.js-qty__adjust--plus',function(e){
		let parent = $(e.target).parents('.js-qty__wrapper').eq(0);
		let current_qty = $(parent).attr('data-quantity');
		let updated_qty = parseInt(current_qty) + 1;
		let current_item = {};
		let key = $(parent).attr('data-key');
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
// 				console.log('got here called');
				refreshCart(data);

			});
			}, error: function (error) {
				console.log(error)
			}
		});
	});



$(document).on('click','.js-qty__adjust--minus',function(e){
		let parent = $(e.target).parents('.js-qty__wrapper').eq(0);
		let current_qty = $(parent).attr('data-quantity');
		let updated_qty = parseInt(current_qty) - 1;
		let current_item = {};
		if (updated_qty <= 0) {
			updated_qty = 0;
		}
		let key = $(parent).attr('data-key');
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
// 				console.log('got here called');
				refreshCart(data);

			});
			}, error: function (error) {
				console.log(error)
			}
		});
	});


$(document).on('click','.remove-cart-product',function(e){

		e.preventDefault();
		let current_em = $(e.target);
		let key = $(current_em).attr('data-key');

		let updated_qty = 0;
		let current_item = {};
		current_item[key] = updated_qty;
		$.ajax({
			url: "/cart/update.js",
			data: { 'updates': current_item },
			method: "POST",
			dataType: "JSON",
			success: function (data) {
			$.get('/cart.json', function (cart) {
// 				console.log('got here called');
				refreshCart(data);
			});
			}, error: function (error) {
				console.log(error)
			}
		});
	})



});
$(document).ready(function () {
  $(document).on('click','.cart_upsell_product',function(e){
    var target = e.target;
    var data_id = $(this).attr("data-id");
    var quantity = 1;
    $.ajax({
      url : "/cart/add.js",
      data: { id : data_id, quantity : quantity },
      method : "POST",
      dataType : "JSON",
      success : function(data) {
      	refreshCart(data);
      },
      error : function(data) {

      }
    });
  });
   });


//  sticky atc button


$(document).ready(function(){
$( ".btn-custom-yellow" ).on( "click", function() {
	console.log(204);
  $( ".js_sticky_pro_atc" ).trigger( "click" );
   refreshCart();
});

  $( ".js_sticky_pro_atc" ).on( "click", function() {
  });


  /* sales popup js start here */
	var popup = $('.salesPopup');
	var visitorCount = $('.salesPopup__visitorCount');
	var visitHour = $('.salesPopup__visitorHour');
	var orderCount = $('.salesPopup__OrdeCount');
	var orderHour = $('.salesPopup__OrderHour');

	function generateVisitorCount(){
		return Math.floor(Math.random() * 101);
	}

	function generateRandomTime() {
		// Generate a random time interval between 0 to 2 hours in milliseconds
		return Math.floor(Math.random() * 7200000);
	}

	function generateOrderNumber() {
		return Math.floor(Math.random() * 151);
	}

	function generateOrderDays() {
        Math.floor(Math.random() * 3) + 1;
    }

	function formatTime(milliseconds) {
		var hours = Math.floor(milliseconds / 3600000);
		var minutes = Math.floor((milliseconds % 3600000) / 60000);
		if (hours === 0) {
			return minutes + " minutes";
		} else {
			return hours + " hours " + minutes + " minutes";
		}
	}

	function openPopup() {
		var randomVisitor = generateVisitorCount();

		var randomTime = generateRandomTime();
		var formattedTime = formatTime(randomTime);

		var orderNumber = generateOrderNumber();

		var orderDays = generateOrderDays();

		visitorCount.text(randomVisitor);
		visitHour.text(formattedTime);
		orderCount.text(orderNumber);
		orderHour.text(orderDays);


		popup.addClass('show'); // Add 'show' class to display the popup
		setTimeout(closePopup, 10000); // Auto close after 10 seconds
	}

	function closePopup() {
		popup.removeClass('show');
	}

	function startPopupInterval() {
		openPopup();
		setInterval(openPopup, 45000); // Open popup every 30 seconds
	}

	setTimeout(() => {
		startPopupInterval();
	}, 10000);
});

$(document).ready(function() {
    // Update the countdown every 1 second
    var countdown = setInterval(function() {
        // Get the current timestamp in seconds
        var currentTS = Math.floor(Date.now() / 1000);

        // Calculate the remaining time in seconds
        var timeToCount = window.userTimeStamp - currentTS;

        // Calculate days, hours, minutes, and seconds
        var days = Math.floor(timeToCount / (60 * 60 * 24));
        var hours = Math.floor((timeToCount % (60 * 60 * 24)) / (60 * 60));
        var minutes = Math.floor((timeToCount % (60 * 60)) / 60);
        var seconds = timeToCount % 60;

        // Display the countdown
        $(".days .data").text(days);
        $(".hourse .data").text(hours);
        $(".minute .data").text(minutes);
        $(".seconds .data").text(seconds);

        // If the countdown is over, you can add additional actions here
        if (timeToCount <= 0) {
            clearInterval(countdown);
            console.log("Countdown expired!");
        }
    }, 1000);


    /*!
     * @preserve
     *
     * Readmore.js jQuery plugin
     */
    (function ( $ ) {

        /*
        Plugin: ShowMore
        author: dtasic@gmail.com
        */

        $.fn.showMore = function (options) {

            "use strict";

            var currentelem = 1;

            this.each(function(){

                var currentid = '';
                var element = $(this);
                var auto = parseInt(element.innerHeight())/2;
                var fullheight = element.innerHeight();
                var maxWidth = element.css('width');
                var settings = $.extend({
                    minheight: auto,
                    buttontxtmore: "show more",
                    buttontxtless: "show less",
                    buttoncss: "showmore-button",
                    animationspeed: auto
                }, options );

                element.attr('id') != undefined ? currentid = element.attr('id') : currentid = currentelem;
                element.wrap( "<div id='showmore-"+currentid+"' data-showmore"+(maxWidth == '0px' ? "" : " style='max-width:"+maxWidth+";'")+"></div>" );

                if (element.parent().not('[data-showmore]')) {

                    if (fullheight > settings.minheight) {

                        element.css('min-height', settings.minheight).css('max-height', settings.minheight).css('overflow', 'hidden');
                        var showMoreButton = $("<div />", {
                            id: "showmore-button-"+currentid,
                            "class": settings.buttoncss,
                            click: function() {

                                if (element.css('max-height') != 'none') {
                                    element.css('height', settings.minheight).css('max-height', '').animate({height:fullheight}, settings.animationspeed, function () { showMoreButton.html(settings.buttontxtless); });
                                } else {
                                    element.animate({height:settings.minheight}, settings.animationspeed, function () { showMoreButton.html(settings.buttontxtmore); element.css('max-height', settings.minheight); });
                                }
                            },
                            html: settings.buttontxtmore
                        });

                        element.after(showMoreButton);

                    }

                    currentelem++;

                }

            });

            return this;

        };

    }(jQuery));

	if($('.js-read-more').height() > 119){
		$('.js-read-more').showMore({
			minheight: 119,
			buttontxtmore: 'See more',
			buttontxtless: 'See less',
			buttoncss: 'read-more__link',
			animationspeed: 250
		});
	}
    $(document).on('click', '.read-more__link', function(){
  		$(this).toggleClass('removeAfter');
  	});
});



